// extracted by mini-css-extract-plugin
module.exports = {"turnscreen":"Turnscreen_turnscreen__WQNmh","title":"Turnscreen_title__1LE0y","subtext":"Turnscreen_subtext__QiKSB"};